import { render, staticRenderFns } from "./deliverys-designs-classes-input.vue?vue&type=template&id=af737eb8&"
import script from "./deliverys-designs-classes-input.vue?vue&type=script&lang=js&"
export * from "./deliverys-designs-classes-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports